<script>
import FeaturePlaceholder from './FeaturePlaceholder.vue';
import Icon from 'dashboard/components-next/icon/Icon.vue';
export default {
  components: { FeaturePlaceholder, Icon },
  props: {
    message: {
      type: String,
      required: true,
    },
  },
};
</script>

<template>
  <div class="flex h-full w-full items-center justify-center px-5 py-8">
    <div
      class="flex w-full max-w-md flex-col items-center rounded-2xl border border-n-weak bg-n-solid-1 px-6 py-8 text-center shadow-sm"
    >
      <div
        class="relative mb-5 grid size-16 place-items-center rounded-2xl bg-n-brand/10 text-n-brand"
      >
        <Icon icon="i-lucide-messages-square" class="size-7" />
        <span
          class="absolute -right-1 -top-1 size-3 rounded-full border-2 border-n-solid-1 bg-n-teal-9"
        />
      </div>
      <span class="max-w-sm text-base font-semibold leading-6 text-n-slate-12">
        {{ message }}
      </span>
      <div class="mt-5 h-px w-16 bg-n-weak" />
      <FeaturePlaceholder />
    </div>
  </div>
</template>
